export const BANNER_INFO = [
  {
    COLUMN: "순번",
    WIDTH: 25,
  },
  {
    COLUMN: "제목",
    WIDTH: 50,
  },
  {
    COLUMN: "연결된 공지사항",
    WIDTH: 25,
  },
];
